import dayjs from 'dayjs';
import { VALIDATIONS } from '../../../constants/validations';
import { commonValidations } from '../../../utils/validations';

export const projectFormValidations = (isEn) => ({
  // 프로젝트 정보
  title: {
    required: isEn ? 'Please enter the project name.' : '프로젝트명을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the project name.' : '프로젝트명을 입력해주세요.';
      }
      if (!VALIDATIONS.TITLE.regex.test(value)) {
        return isEn ? VALIDATIONS.TITLE.messageEn : VALIDATIONS.TITLE.message;
      }
      return true;
    },
  },
  area: {
    required: isEn ? 'Please select the area.' : '분야를 선택해주세요.',
  },
  subArea: {
    required: isEn ? 'Please select the sub-area.' : '세부분야를 선택해주세요.',
  },
  methodologySeq: {
    required: isEn ? 'Please select the methodology.' : '방법론을 선택해주세요.',
  },
  reductionStartDate: {
    required: isEn ? 'Please select the reduction start date.' : '감축 시작일을 선택해주세요.',
  },
  reductionEndDate: {
    required: isEn ? 'Please select the reduction end date.' : '감축 종료일을 선택해주세요.',
  },
  purpose: {
    required: isEn ? 'Please enter the purpose.' : '목적을 입력해주세요.',
  },
  content: {
    required: isEn ? 'Please enter the content.' : '내용을 입력해주세요.',
  },
  'location.addr1': {
    required: isEn ? 'Please select an address.' : '주소를 선택해주세요.',
  },
  // 담당자 정보
  name: {
    required: isEn ? 'Please enter the name.' : '이름을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the name.' : '이름을 입력해주세요.';
      }
      return true;
    },
  },
  phone: commonValidations(isEn).phone,
  email: commonValidations(isEn).email,
  reductionBase: {
    required: isEn ? 'Please enter the baseline emission (absorption).' : '베이스라인 배출량 (흡수량)을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the baseline emission (absorption).' : '베이스라인 배출량 (흡수량)을 입력해주세요.';
      }
      return true;
    },
  },
  reductionBusiness: {
    required: isEn ? 'Please enter the business emission (absorption).' : '사업 배출량 (흡수량)을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the business emission (absorption).' : '사업 배출량 (흡수량)을 입력해주세요.';
      }
      return true;
    },
  },
  reductionLeak: {
    required: isEn ? 'Please enter the leakage.' : '누출량을 입력해주세요.',
    validate: (value) => {
      if (!value || `${value}`?.trim().length === 0) {
        return isEn ? 'Please enter the leakage.' : '누출량을 입력해주세요.';
      }
      return true;
    },
  },
  workplaceImages: {
    required: isEn ? 'Please upload the workplace images.' : '작업장 이미지를 업로드해주세요.',
    validate: (value) => {
      if (!value || value?.length === 0) {
        return isEn ? 'Please upload the workplace images.' : '작업장 이미지를 업로드해주세요.';
      }
      return true;
    },
  },
  monitoringPlan: {
    required: isEn ? 'Please enter the monitoring plan.' : '모니터링 계획을 입력해주세요.',
  },
});

export const projectInitialValues = {
  site: '',
  fax: '',
  name: '',
  phone: '',
  department: '',
  email: '',
  isExported: false,
  title: '',
  area: 'Removal',
  subArea: '',
  startDate: dayjs(),
  endDate: dayjs().add(1, 'year'),
  reductionStartDate: dayjs(),
  reductionEndDate: dayjs().add(1, 'year'),
  methodologySeq: '',
  purpose: '',
  content: '',
  location: {
    addr1: '',
    addr2: '',
  },
  isDomestic: false,
  workplaceImages: [],
  reductionBase: '',
  reductionBusiness: '',
  reductionLeak: '',
  reduction: '',
  monitoringType: '',
  monitoringPlan: '',
  beforeImages: [],
  afterImages: [],
  evidence: [],
  proofFile: '',
  isTermsAgree: false, // 방법론 약관 동의 여부
  //타기관
  exportedTitle: '',
  exportedOrgan: '',
  exportedDate: dayjs(),
};
